import React from 'react';
import Filter from '../components/FilterSection';
import Line from '../components/LineaSection';
import Graphic from '../components/GraphicSection';
import domtoimage from 'dom-to-image';
import SocketClient from "socket.io-client";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dashActs from "../../Actions/Dashboard";

import { api_base } from "../../constants/services/api";
import { makeId } from '../../Services/service';
import { loadData } from '../components/LoadData'

import '../style.css'

class CruceContainer extends React.Component {
  state = {
    filter: {
      fenomeno: [],
      medioArma: [],
      genero: [],
      etario: [],
      year: [new Date().getFullYear()],
      month: [],
      socketPath: makeId()
    },
    general: [],
    siedco: [],
    secad: [],
    dataLines: [],
    lineIndex: 0,
    lines: [],
    chartType: 'line',
    chartTags: false
  }

  collectImage = () => {
    var node = document.getElementById('chart-container');
    node.classList.add("animate-insert");
    domtoimage.toPng(node).then((dataUrl) => {
      this.props.dashActions.accumulateGraphics(
        dataUrl,
        "img",
        node.offsetWidth,
        node.offsetHeight
      );
      setTimeout(() => {
        node.classList.remove("animate-insert");
      }, 200);
    });
  }

  downloadImage = () => {
    var node = document.getElementById('chart-container');
    domtoimage.toBlob(node)
      .then(blob => window.saveAs(blob, 'grafica.png'));
  }

  buttonHandler = (data, filterType) => {
    const prevar = this.state[filterType]
    let variable = prevar[data.variable]
    if (variable.includes(data.id)) {
      variable = variable.filter(i => i !== data.id)
    } else {
      variable.push(data.id)
    }
    let filter = {
      ...this.state[filterType],
      [data.variable]: variable
    }
    this.setState({
      [filterType]: {
        ...filter
      }
    }, () => {
      this.now = new Date().getTime().toString();
      this.state.lines.forEach(l => this.sendData(l.i))
    })
  }

  changeChart = () => {
    if (this.state.chartType === 'line') this.setState({ chartType: 'barr' })
    else this.setState({ chartType: 'line' })
  }

  changeTags = () => {
    this.setState({ chartTags: !this.state.chartTags })
  }

  lineSelect = (data, line) => {
    const lines = this.state.lines.map(l => {
      return {
        ...l,
        title: line.i === l.i ? data.title : l.title,
        id: line.i === l.i ? data.id : l.id,
        variable: line.i === l.i ? data.variable : l.variable,
      }
    });
    this.setState({ lines }, () => {
      this.now = new Date().getTime().toString();
      this.sendData(line.i)
    })
  }

  addLine = () => {
    let lines = this.state.lines;
    lines.push({
      i: this.state.lineIndex,
      eye: true,
      color: this.randomColor(),
      data: []
    })
    this.setState({ lineIndex: this.state.lineIndex + 1, lines })
  }

  removeLine = (i) => {
    let lines = this.state.lines.filter(line => line.i !== i)
    this.setState({ lines })

  }

  eyeChange = (i) => {
    let lines = this.state.lines.map(line => {
      return {
        ...line,
        eye: line.i === i ? !line.eye : line.eye
      }
    })
    this.setState({ lines })
  }

  changeColor = (e, i) => {
    let lines = this.state.lines.map(line => {
      return {
        ...line,
        color: line.i === i ? e.target.value : line.color
      }
    })
    this.setState({ lines })
  }

  randomColor = () => {
    const c1 = Math.floor(Math.random() * 255)
    const c2 = Math.floor(Math.random() * 255)
    const c3 = Math.floor(Math.random() * 255)
    return `#${this.setColorHex(c1)}${this.setColorHex(c2)}${this.setColorHex(c3)}`
  }

  setColorHex = (c) => {
    return c < 16 ? '0' + c.toString(16) : c.toString(16)
  }

  componentDidMount() {
    loadData().then(data => this.setState({ ...data }))
    this.socket = SocketClient(api_base + "/api/v1/dash/cruce");
    this.socket.on(this.state.filter.socketPath, (data) =>
      this.recieveData(data)
    );
  }

  componentWillUnmount() {
    this.socket.disconnect();
  }

  sendData = (i) => {
    const line = this.state.lines.filter(l => l.i === i).reduce((pre, cur) => cur, {})
    const filter = {
      ...this.state.filter,
      [line.variable]: [line.id]
    }
    this.socket.emit(
      "evento",
      JSON.stringify({
        ...filter,
        now: this.now,
        i: line.i,
        token: this.props.session.token,
      })
    );
  }

  recieveData = (resp) => {
    let data = JSON.parse(resp);
    if (data.notToken) {
      alert("Problemas con la sesión")
      return;
    }
    if (data.now !== this.now) return;
    const lines = this.state.lines.map(line => {
      return {
        ...line,
        data: line.i === data.i ? data.data : line.data
      }
    })
    this.setState({ lines })
  };


  render() {
    console.log('props', this.props)
    return (
      <div className='cruce-container'>
        <div className='overflow-auto'>
          <Line
            state={this.state}
            lineSelect={this.lineSelect}
            addLine={this.addLine}
            removeLine={this.removeLine}
            eyeChange={this.eyeChange}
            changeColor={this.changeColor}
          />
        </div>
        <div className='overflow-auto'>
          <Filter
            state={this.state}
            buttonHandler={this.buttonHandler}
          />
        </div>
        <div>
          <Graphic
            state={this.state}
            onChangeChart={this.changeChart}
            onActiveTags={this.changeTags}
            onCollectImage={this.collectImage}
            onDownloadImage={this.downloadImage}
          />
        </div>
      </div>
    )
  }
}

function mapStateToProprs(state) {
  return {
    session: state.session,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dashActions: bindActionCreators(dashActs, dispatch),
  };
}
export default connect(mapStateToProprs, mapDispatchToProps)(CruceContainer);
